import React from 'react';
import pt from 'prop-types';

import { classNames } from 'utils';

import Icon from 'components/icon';
import Link from 'components/link';
import { EasyblocksBackendContext } from 'components/storefront/editor/backendContext';

import './sidebar-panel.scss';

const animationTime = 150;

export default class SidebarPanel extends React.PureComponent {
  static propTypes = {
    title: pt.string.isRequired,
    subtitle: pt.string,
    value: pt.any,
    lifecycleRef: pt.object,
    footerActions: pt.any,
    children: pt.any,
    onSave: pt.func,
    onCancel: pt.func,
    onClose: pt.func,
    onClickNew: pt.func,
    className: pt.string,
  };

  static contextType = EasyblocksBackendContext;

  constructor(props) {
    super(props);

    this.state = {
      closing: false,
      initialValue: props.value,
    };
  }

  componentDidMount() {
    const { disableSave } = this.context;

    disableSave();
  }

  componentDidUpdate(prevProps) {
    const { lifecycleRef } = this.props;

    if (lifecycleRef && lifecycleRef !== prevProps.lifecycleRef) {
      lifecycleRef.current = lifecycleRef.current || {};

      Object.assign(lifecycleRef.current, {
        close: this.closePanel,
      });
    }
  }

  componentWillUnmount() {
    const { enableSave } = this.context;

    enableSave();
  }

  closePanel = async () => {
    const { onClose } = this.props;

    this.setState({ closing: true });

    await new Promise((resolve) => {
      setTimeout(resolve, animationTime);
    });

    onClose?.();
  };

  onClickCancel = () => {
    const { value, onCancel } = this.props;
    const { initialValue } = this.state;

    if (value !== initialValue) {
      this.context.openModal('ConfirmRouteLeave', {
        onConfirm: () => {
          onCancel?.(initialValue);
          this.closePanel();
        },
      });
    } else {
      onCancel?.(initialValue);
      this.closePanel();
    }
  };

  onClickSave = () => {
    const { onSave } = this.props;

    onSave?.();
    this.closePanel();
  };

  render() {
    const { title, subtitle, footerActions, children, className, onClickNew } =
      this.props;
    const { closing } = this.state;

    return (
      <>
        <div
          aria-hidden={closing}
          className={classNames(
            'storefront-editor--sidebar-panel--group',
            className,
          )}
        >
          <div
            aria-hidden={closing}
            className="storefront-editor--sidebar-panel"
          >
            <header className="storefront-editor--sidebar-panel--header">
              <div className="storefront-editor--sidebar-panel--header--content">
                <button
                  aria-label="Back"
                  className="storefront-editor--sidebar-panel--back"
                  onClick={this.onClickCancel}
                  type="button"
                >
                  <Icon fa="chevron-left" />
                </button>

                <button
                  className="storefront-editor--sidebar-panel--back--wrapper"
                  onClick={this.onClickCancel}
                  type="button"
                >
                  <h2 className="storefront-editor--sidebar-panel--header--title">
                    {title}
                  </h2>

                  {subtitle && (
                    <h3 className="storefront-editor--sidebar-panel--header--subtitle">
                      {subtitle}
                    </h3>
                  )}
                </button>
              </div>

              {onClickNew && (
                <div className="storefront-editor--sidebar-panel--header--actions">
                  <Link className="as-link" onClick={onClickNew}>
                    Create new
                  </Link>
                </div>
              )}
            </header>

            <section className="storefront-editor--sidebar-panel--body">
              {children}
            </section>
          </div>
        </div>

        <footer
          aria-hidden={closing}
          className="storefront-editor--sidebar-panel--footer"
        >
          {footerActions}

          <button
            className="button button-sm button-secondary"
            onClick={this.onClickCancel}
            type="button"
          >
            Cancel
          </button>

          <button
            className="button button-sm button-primary"
            onClick={this.onClickSave}
            type="button"
          >
            Save
          </button>
        </footer>
      </>
    );
  }
}
